/*
  Pop-up "rasca y gana" (sections/scratch-popup.liquid).
  - Se abre una vez por visitante (localStorage).
  - NO se abre nada más llegar (tapaba el producto a quien venía de un anuncio). Se abre con lo
    primero que ocurra, siempre tras un mínimo de 8 s en la página:
      · Ordenador: cuando el ratón sale por arriba de la ventana (intención de irse).
      · Móvil: cuando el visitante ha bajado más de la mitad de la página.
      · Si no pasa nada de lo anterior: a los 25 s.
  - No se abre si el código ya está aplicado (cookie discount_code de Shopify) ni si el carrito u
    otro diálogo están abiertos.
  - La capa de rascar se dibuja en un <canvas>; al despejar ~45 % se revela entera.
*/
(() => {
  const dialog = document.querySelector('[data-scratch-popup]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const STORAGE_KEY = 'kalmora-scratch-popup';
  const REVEAL_AT = 0.45;
  const MIN_TIME_ON_PAGE = 8000;
  const FALLBACK_DELAY = 25000;
  const code = dialog.dataset.code;
  const days = Number(dialog.dataset.days || 14);
  const designMode = dialog.dataset.designMode === 'true';

  const card = dialog.querySelector('[data-scratch-card]');
  const canvas = dialog.querySelector('[data-scratch-canvas]');
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  const before = dialog.querySelector('[data-scratch-before]');
  const after = dialog.querySelector('[data-scratch-after]');
  const live = dialog.querySelector('[data-scratch-live]');
  const prize = dialog.querySelector('[data-scratch-prize]');
  const copyButton = dialog.querySelector('[data-scratch-copy]');
  const copyLabel = dialog.querySelector('[data-scratch-copy-label]');

  let revealed = false;
  let drawing = false;
  let last = null;
  let moves = 0;

  /* ── ¿Mostrarlo? ─────────────────────────────── */
  function seenRecently() {
    try {
      const saved = Number(localStorage.getItem(STORAGE_KEY));
      return saved && Date.now() - saved < days * 864e5;
    } catch (e) {
      return false;
    }
  }

  function remember() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {
      /* sin almacenamiento: puede volver a salir, no pasa nada */
    }
  }

  function codeAlreadyApplied() {
    return document.cookie.split('; ').some((c) => c.toLowerCase() === `discount_code=${code.toLowerCase()}`);
  }

  /* ── Capa de rascar ──────────────────────────── */
  function paintCover() {
    const rect = card.getBoundingClientRect();
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(rect.width * ratio);
    canvas.height = Math.round(rect.height * ratio);
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);

    const styles = getComputedStyle(document.documentElement);
    const ink = styles.getPropertyValue('--color-night').trim() || '#141110';
    const surface = styles.getPropertyValue('--color-night-surface').trim() || '#221D1B';
    const text = styles.getPropertyValue('--color-night-text').trim() || '#EAE3D9';
    const font = styles.getPropertyValue('--font-ui').trim() || 'sans-serif';

    ctx.globalCompositeOperation = 'source-over';
    const gradient = ctx.createLinearGradient(0, 0, rect.width, rect.height);
    gradient.addColorStop(0, surface);
    gradient.addColorStop(0.5, ink);
    gradient.addColorStop(1, surface);
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, rect.width, rect.height);

    // Trama fina para que parezca una tarjeta de rascar
    ctx.strokeStyle = 'rgba(255,255,255,0.05)';
    ctx.lineWidth = 1;
    for (let x = -rect.height; x < rect.width; x += 8) {
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x + rect.height, rect.height);
      ctx.stroke();
    }

    ctx.fillStyle = text;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = `600 13px ${font}`;
    ctx.fillText('R A S C A   A Q U Í', rect.width / 2, rect.height / 2 - 10);
    ctx.font = `400 12px ${font}`;
    ctx.globalAlpha = 0.7;
    ctx.fillText('Tu regalo está debajo', rect.width / 2, rect.height / 2 + 14);
    ctx.globalAlpha = 1;
    card.classList.add('is-ready');
  }

  function point(event) {
    const rect = canvas.getBoundingClientRect();
    return { x: event.clientX - rect.left, y: event.clientY - rect.top };
  }

  function scratch(from, to) {
    ctx.globalCompositeOperation = 'destination-out';
    ctx.strokeStyle = '#000';
    ctx.globalAlpha = 1;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.lineWidth = Math.max(28, card.clientWidth * 0.09);
    ctx.beginPath();
    ctx.moveTo(from.x, from.y);
    ctx.lineTo(to.x, to.y);
    ctx.stroke();
  }

  function clearedRatio() {
    const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
    let clear = 0;
    let total = 0;
    for (let i = 3; i < data.length; i += 64) {
      total += 1;
      if (data[i] === 0) clear += 1;
    }
    return clear / total;
  }

  function reveal() {
    if (revealed) return;
    revealed = true;
    card.classList.add('is-revealed');
    prize.removeAttribute('aria-hidden');
    before.hidden = true;
    after.hidden = false;
    live.textContent = `Has ganado ${dialog.dataset.amount} de descuento. Tu código es ${code}.`;
    after.querySelector('a, button').focus({ preventScroll: true });
  }

  canvas.addEventListener('pointerdown', (event) => {
    if (revealed) return;
    drawing = true;
    last = point(event);
    canvas.setPointerCapture(event.pointerId);
    scratch(last, { x: last.x + 0.1, y: last.y });
  });

  canvas.addEventListener('pointermove', (event) => {
    if (!drawing || revealed) return;
    const next = point(event);
    scratch(last, next);
    last = next;
    moves += 1;
    if (moves % 6 === 0 && clearedRatio() >= REVEAL_AT) reveal();
  });

  ['pointerup', 'pointercancel', 'pointerleave'].forEach((type) =>
    canvas.addEventListener(type, () => {
      if (drawing && !revealed && clearedRatio() >= REVEAL_AT) reveal();
      drawing = false;
    })
  );

  /* ── Botones ─────────────────────────────────── */
  dialog.querySelector('[data-scratch-reveal]').addEventListener('click', reveal);
  dialog.querySelector('[data-scratch-close]').addEventListener('click', () => dialog.close());

  // Clic en el fondo oscuro = cerrar
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  copyButton.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(code);
      copyLabel.textContent = 'Copiado';
    } catch (e) {
      copyLabel.textContent = code;
    }
    live.textContent = 'Código copiado';
    setTimeout(() => (copyLabel.textContent = 'Copiar código'), 1500);
  });

  /* ── Abrir ───────────────────────────────────── */
  function open() {
    if (dialog.open) return;
    revealed = false;
    card.classList.remove('is-revealed', 'is-ready');
    prize.setAttribute('aria-hidden', 'true');
    before.hidden = false;
    after.hidden = true;
    dialog.showModal();
    paintCover();
    remember();
  }

  if (designMode) {
    // Editor de temas: solo al seleccionar la sección
    document.addEventListener('shopify:section:select', (event) => {
      if (event.target.contains(dialog)) open();
    });
    document.addEventListener('shopify:section:deselect', () => dialog.open && dialog.close());
    return;
  }

  if (new URLSearchParams(location.search).has('rasca')) {
    // Para probarlo: añade ?rasca a cualquier URL
    setTimeout(open, 300);
    return;
  }

  if (seenRecently() || codeAlreadyApplied()) return;

  /* ── Cuándo abrir: sin interrumpir al llegar ── */
  const startedAt = Date.now();
  let pending = true;
  let fallbackTimer = null;

  function tryOpen() {
    if (!pending) return;
    if (Date.now() - startedAt < MIN_TIME_ON_PAGE) return;
    // No interrumpir si el visitante tiene abierto el carrito u otro diálogo
    if (document.querySelector('dialog[open]')) return;
    pending = false;
    cleanup();
    open();
  }

  function onMouseOut(event) {
    // El ratón sale de la ventana por arriba (hacia las pestañas o la barra de direcciones)
    if (!event.relatedTarget && event.clientY <= 0) tryOpen();
  }

  function onScroll() {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= 0.5) tryOpen();
  }

  function cleanup() {
    document.removeEventListener('mouseout', onMouseOut);
    window.removeEventListener('scroll', onScroll);
    clearTimeout(fallbackTimer);
  }

  const hasMouse = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (hasMouse) {
    document.addEventListener('mouseout', onMouseOut);
  } else {
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Último recurso: si no ha pasado nada, a los 25 s (y reintenta si en ese momento había un diálogo abierto)
  (function scheduleFallback(wait) {
    fallbackTimer = setTimeout(() => {
      tryOpen();
      if (pending) scheduleFallback(5000);
    }, wait);
  })(FALLBACK_DELAY);
})();
